import React from 'react';
import { Box, Button, Stack, Typography, alpha } from '@mui/material';
import { getAccentColor, getBodyColor } from './shared';
import { getPublicMapEmbedUrl, getStoredPublicSchoolProfile } from '../../publicSchoolProfile';

const MapVisitSection = ({ section, sectionKey, sectionIndex, mediaHeight, openActionPath, bodyContent, renderPositionableElement }) => {
  const accent = getAccentColor(section) || '#4F46E5';
  const bodyColor = getBodyColor(section) || '#64748B';
  const publicProfile = getStoredPublicSchoolProfile();
  const resolvedAddress = section.mapAddress || publicProfile.address || '';
  const resolvedMapEmbedUrl = section.mapEmbedUrl || getPublicMapEmbedUrl(publicProfile);

  return (
    <Box component="section" sx={{ py: { xs: 1, md: 1.6 }, width: '100%' }}>
      <Box sx={{ display: 'grid', gap: { xs: 1.5, md: 2.4 }, gridTemplateColumns: { xs: '1fr', md: '0.8fr 1.2fr' }, alignItems: 'center' }}>
        <Box sx={{ p: { xs: 3, md: 5 }, borderRadius: '32px', backgroundColor: alpha(accent, 0.03), border: `1px solid ${alpha(accent, 0.1)}` }}>
          <Stack spacing={3}>
            {section.title && <Typography sx={{ color: '#0F172A', fontWeight: 800, fontSize: { xs: '1.8rem', md: '2.25rem' }, lineHeight: 1.1 }}>{section.title}</Typography>}
            {bodyContent && <Box sx={{ color: bodyColor, fontSize: '1.05rem', lineHeight: 1.7 }}>{bodyContent}</Box>}
            {resolvedAddress && (
              <Box sx={{ p: 2.5, borderRadius: '6px', backgroundColor: '#FFFFFF', boxShadow: `0 4px 20px ${alpha('#0F172A', 0.04)}` }}>
                <Typography sx={{ color: accent, fontWeight: 800, fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', mb: 0.5 }}>Address</Typography>
                <Typography sx={{ color: '#0F172A', fontWeight: 600, lineHeight: 1.5 }}>{resolvedAddress}</Typography>
              </Box>
            )}
            {section.buttonEnabled && section.buttonPath && (
              <Button variant="contained" onClick={() => openActionPath(section.buttonPath)} sx={{ borderRadius: '100px', px: 4, py: 1.5, width: 'fit-content', backgroundColor: accent, color: '#FFFFFF', fontWeight: 700, fontSize: '1rem', textTransform: 'none', boxShadow: `0 8px 20px ${alpha(accent, 0.3)}`, '&:hover': { backgroundColor: accent, transform: 'translateY(-2px)' }, transition: 'all 0.2s' }}>
                {section.buttonLabel || 'Get Directions'}
              </Button>
            )}
          </Stack>
        </Box>

        {renderPositionableElement({
          section, index: sectionIndex, elementKey: `${sectionKey}-map-frame`,
          children: resolvedMapEmbedUrl ? (
            <Box sx={{ borderRadius: '32px', overflow: 'hidden', boxShadow: `0 20px 40px ${alpha('#0F172A', 0.1)}`, border: `4px solid #FFFFFF` }}>
              <Box component="iframe" src={resolvedMapEmbedUrl} title={`${section.title || 'Campus'} Map`} loading="lazy" referrerPolicy="no-referrer-when-downgrade" sx={{ width: '100%', height: { xs: 350, md: Math.max(400, Number(mediaHeight) || 450) }, border: 0, display: 'block' }} />
            </Box>
          ) : (
            <Box sx={{ height: { xs: 350, md: 450 }, display: 'grid', placeItems: 'center', borderRadius: '32px', border: '2px dashed #CBD5E1', backgroundColor: '#F8FAFC' }}>
              <Typography sx={{ color: '#94A3B8', fontWeight: 700 }}>Add map embed URL</Typography>
            </Box>
          ),
        })}
      </Box>
    </Box>
  );
};
export default MapVisitSection;
